export { default as BoletaSalida } from "./BoletaSalida";
